import React from "react";
import { connect } from "react-redux";
import userPhotoPlaceholder from "../../assets/userPhotoPlaceholder.png";
import "./styles.account.status.css";
import { getStorage } from "../../utils/storage";
import icons from "../../constants/icons";

class AccountStatus extends React.Component {
  state = {
    user: {},
  };

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });
  };

  render() {
    return (
      <div className="account-status-container">
        <center className="account-status-profile">
          <img src={userPhotoPlaceholder} />
          <div>
            <center className="mb-2">
              <h2>{this.state?.user?.user?.fullName}</h2>
              <p>Public ID: {this.state?.user?.user?.publicId}</p>
            </center>
            <div
              className={`badge badge-${
                this.state?.user?.verified ? "success" : "danger"
              }`}
              style={{ maxWidth: "30%" }}
            >
              <span>
                {this.state.user?.verified ? "Verified" : "Unverified"}
              </span>
            </div>
          </div>
        </center>
        <div className="account-status-body">
          <ul className="list-group">
            {this.props.profileUnits.map((el, i) => {
              return (
                <li
                  className="list-group-item account-status-list-item"
                  key={i}
                >
                  <span style={{ flex: 1 }}>{el.unit}</span>
                  <div className="account-status-action">
                    <div
                      className={`icon-container ${
                        el.provided ? "active" : ""
                      }`}
                    >
                      <span className={process.env.REACT_APP_ICONS_TYPE}>
                        {el.provided ? icons.success : icons.failed}
                      </span>
                    </div>
                    Provided
                  </div>
                  <div className="account-status-action">
                    <div
                      className={`icon-container ${
                        el.approved ? "active" : ""
                      }`}
                    >
                      <span className={process.env.REACT_APP_ICONS_TYPE}>
                        {el.provided ? icons.success : icons.failed}
                      </span>
                    </div>
                    Approved
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
        {!this.state.user.verified && (
          <center className="card-footer">Your account is under review</center>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { profileUnits } = state.ProfileUnits;
  return {
    profileUnits,
  };
};

export default connect(mapStateToProps)(AccountStatus);
